const { REACT_APP_PORT } = process.env;

let port = "30010";
if (window.location.protocol === 'https:') {
    port = "30011";
}
if (REACT_APP_PORT) {
    port = REACT_APP_PORT;
}

if (window?.location?.hostname == '68.183.239.207' || window?.location?.hostname == 'chr.digitalworks.mn' || window?.location?.hostname == 'hr.diwo.mn') {
    if (window?.location?.protocol === 'https:') {
        port = '443';
    } else {
        port = '80';
    }
}

let baseURI = window.location.protocol.concat("//").concat(window.location.hostname).concat(":").concat(port).concat("/");
if (window?.location?.hostname == 'localhost') {
    baseURI = 'http://68.183.239.207/';
}

const baseConfig = {
    baseurl: baseURI
}

export { baseConfig };